import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { EntityApiService } from './entity.service';
import { loadEntityList, loadEntityListSuccess, loadEntityListFailure } from './entity.actions';

@Injectable()
export class EntityEffects {
  private actions$ = inject(Actions);
  private entityService = inject(EntityApiService);

  loadEntityList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEntityList),
      mergeMap(() =>
        this.entityService.getEntityList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadEntityListFailure({ error: response.message });
            }
            return loadEntityListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadEntityListFailure({ error })))
        )
      )
    )
  );
}
